import React, { FC } from 'react';

import { Menu } from 'antd';
import { MenuMode } from 'antd/lib/menu';
import routePaths, { isRouteDefined } from 'config/routes';
import { isEmpty } from 'lodash';
import { useRouter } from 'next/router';
import Link from 'src/components/Link';
import { UserStatusEnum } from 'src/shared/enums';
import { IMenu } from 'src/shared/models';
import { defaultLanguage, getTranslatedData, requestOrderStatus } from 'utils';
import { connect } from 'react-redux';
import { IRootReducers } from 'src/reducers';

interface OwnProps {
  className?: string;
  menu: Array<IMenu>;
  mode: MenuMode;
  onClickItem?: Function;
  userStatus: UserStatusEnum;
}

export const getItemLink = (route: string) => {
  return isRouteDefined(route) ? route : `/static?page=${route}`;
};

type props = ReturnType<typeof mapStateToProps> & OwnProps;

const BasicMenu: FC<props> = ({
  className = 'menu',
  menu,
  mode,
  onClickItem,
  userStatus,
}): JSX.Element => {
  const router = useRouter();
  const renderSubMenu = (item: IMenu): JSX.Element => {
    return (
      <Menu.SubMenu key={item.idMenu} title={<span>{item.name}</span>}>
        {item.subMenu.map((subMenuItem) => {
          if (subMenuItem.visible) {
            return (
              <Menu.Item
                key={subMenuItem.idMenu}
                className={subMenuItem.disabled ? 'disabled' : ''}
                onClick={() => (onClickItem ? onClickItem() : {})}
              >
                {subMenuItem.absolute ? (
                  <a
                    href={subMenuItem.route}
                    className={subMenuItem.disabled ? 'disabled' : ''}
                  >
                    {getTranslatedData(
                      subMenuItem,
                      'content',
                      defaultLanguage
                    ) || subMenuItem.name}
                  </a>
                ) : (
                  <Link href={getItemLink(subMenuItem.route)}>
                    <a className={subMenuItem.disabled ? 'disabled' : ''}>
                      {getTranslatedData(
                        subMenuItem,
                        'content',
                        defaultLanguage
                      ) || subMenuItem.name}
                    </a>
                  </Link>
                )}
              </Menu.Item>
            );
          }
        })}
      </Menu.SubMenu>
    );
  };

  const renderMenuItems = (): JSX.Element[] =>
    menu
      ?.sort((a: IMenu, b: IMenu) => a.order - b.order)
      .map((item: IMenu): JSX.Element => {
        const { subMenu } = item;
        if (item.visible) {
          if (subMenu && !isEmpty(subMenu)) return renderSubMenu(item);

          const disabled =
            item.route === routePaths.PAGES.REQUEST_ORDER &&
            !requestOrderStatus.includes(userStatus)
              ? true
              : item.disabled || false;

          return (
            <Menu.Item
              key={item.route || item.idMenu}
              className={item.disabled ? 'disabled' : ''}
              disabled={disabled}
              onClick={() => (onClickItem ? onClickItem() : {})}
            >
              {item.absolute ? (
                <a
                  href={item.route}
                  className={item.disabled ? 'disabled' : ''}
                >
                  {getTranslatedData(item, 'content', defaultLanguage) ||
                    item.name}
                </a>
              ) : (
                <Link href={getItemLink(item.route)}>
                  <a className={item.disabled ? 'disabled' : ''}>
                    {getTranslatedData(item, 'content', defaultLanguage) ||
                      item.name}
                  </a>
                </Link>
              )}
            </Menu.Item>
          );
        }
      });

  return (
    <Menu
      selectedKeys={[
        router.pathname === '/training/[id]'
          ? '/trainings'
          : router.pathname === '/event/[id]'
          ? '/events'
          : router.pathname,
      ]}
      className={className}
      mode={mode}
    >
      {renderMenuItems()}
    </Menu>
  );
};

const mapStateToProps = (state: IRootReducers) => {
  return {
    user: state.auth.user,
  };
};

export default connect(mapStateToProps, {})(BasicMenu);
